export default String.raw`
<div class="customer-submenu">
    {% if page.QueryString contains 'erp-data' -%}
        <div class="customer-submenu__header submenu-header">
            <div class="navigation-header">
                {% if customer.Authenticated -%}
                    {% unless page.QueryString contains 'orderHash' -%}
                        <button class="pure-button load-erp-data-js load-first-lvl-js parent-container-reload-js" data-template="partials/customer-profile/orders/orders.html" data-url="{{ page.Url }}?tab=erp-orders">
                            <svg width="24" height="24">
                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#long-arrow-left-{{settings.iconStyle}}"></use>
                            </svg>
                        </button>
                    {% endunless -%}
                {% endif -%}
                <div class="erp-name">
                    {{ translations.OrderDetails }}<div class="erp-number-js hidden-js"></div>
                </div>
            </div>
        </div>
        <div class="erp-data-container-js" style="display: none">
            <div class="info-container-js expandable-mechanism-container-js">
                <div class="details-info">
                    <div class="details">
                        <div class="customer-info__content" rv-class-executed="Executed" rv-class-canceled="Canceled">
                            <div class="title">{{ translations.OrdStatus }}</div>
                            <span>{ Status | status }</span>
                            <span class="additional-status" rv-if="StatusExists">
                                (
                                    <span rv-if="PaymentNotPaid" class="not-paid" >{{ translations.NotPaid }}</span>
                                    <span rv-if="PaymentPaid" class="paid" >{{ translations.Paid }}</span>
                                    <span rv-if="PaymentPaidPartially" class="partial">{{ translations.PaidPartially }}</span>
                                    <span rv-if="DeliveryAndPaymentStatusExists"> / </span>
                                    <span rv-if="DeliveryStatus0">{{ translations.ERPDeliveryStatus0 }}</span>
                                    <span rv-if="DeliveryStatus1">{{ translations.ERPDeliveryStatus1 }}</span>
                                    <span rv-if="DeliveryStatus2">{{ translations.ERPDeliveryStatus2 }}</span>
                                    <span rv-if="DeliveryStatus3" class="executed">{{ translations.ERPDeliveryStatus3 }}</span>
                                    <span rv-if="DeliveryStatus4" class="executed">{{ translations.ERPDeliveryStatus4 }}</span>
                                )
                            </span>
                        </div>
                        <div class="customer-info__content">
                            <div class="title">{{ translations.BuyDate }}</div>
                            <span>{ Date | date }</span>
                        </div>
                    </div>
                    <div class="details-info__summary">
                        <div class="row-summ">
                            <div class="title">{{ translations.OrderTotalPrice }} {{ translations.Netto | Downcase }}</div>
                            <span>{ SubtotalValue | price } { Currency }</span>
                        </div>
                        <div class="row-summ">
                            <div class="title">{{ translations.OrderTotalPrice }} {{ translations.Brutto | Downcase }}</div>
                            <span>{ TotalValue | price } { Currency }</span>
                        </div>
                        <div class="summary">
                            <div class="title">{{ translations.OrderTotalPrice }} {{ translations.Brutto | Downcase }}</div>
                            <span>{ TotalValue | price } { Currency }</span>
                        </div>
                    </div>
                </div>
                <button class="pure-button expand-data-js change-arrow-title-js" title="{{ translations.ShowDetails }}">
                    {{ translations.ShowDetails }} 
                    <svg height="16" width="16" class="icon rotate-down dropdown-arrow">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
                    </svg>
                </button>
                <div class="order-details expandable-js">
                    <div class="order-details__row">
                        <div class="order-details-item" rv-if="ImplementationDateExists">
                            <div class="title">{{ translations.PaymentDueDate }}</div>
                            <span>{ ImplementationDate | date }</span>
                        </div>
                        <div class="order-details-item">
                            <div class="title">{{ translations.PaymentMethod }}</div>
                            <span>{ PaymentMethod }</span>
                        </div>
                    </div>
                    <div class="order-details__row">
                        <div class="order-details-item" rv-if="DeliveryMethodExists">
                            <div class="title">{{ translations.DelivMethod }}</div>
                            <span>{ DeliveryMethod }</span>
                        </div>
                        <div class="order-details-item" rv-if="EmailExists">
                            <div class="title">{{ translations.BoughtBy }}</div>
                            <span>{ Email }</span>
                        </div>
                        <div class="order-details-item" rv-if="StreetExists">
                            <div class="title">{{ translations.ReciverData }}</div>
                                <span>{ Name1 }</span>
                                <span>{ Name2 }</span>
                                <span>{ Street } { StreetNo }<span rv-if="UnitNoExists">/{ UnitNo }</span></span>
                                <span>{ ZipCode } { City }</span>
                        </div>
                        <div class="order-details-item" rv-if="InvoiceStreetExists">
                            <div class="title">{{ translations.BuyerData }}</div>
                                <span>{ InvoiceName1 }</span>
                                <span>{ InvoiceName2 }</span>
                                <span>{ InvoiceTIN }</span>
                                <span>{ InvoiceStreet } { InvoiceStreetNo }<span rv-if="InvoiceUnitNoExists">/{ InvoiceUnitNo }</span></span>
                                <span>{ InvoiceZipCode } { InvoiceCity }</span>
                        </div>
                    </div>
                    <div class="header-attributes-js" rv-if="AttributesExist"></div>
                </div>
            </div>
            <div class="order-products-list-js container-js">
                {% include 'partials/customer-profile/products-list.html' -%}
            </div>
            <div class="related-erp hidden-js">
                <h5>{{ translations.RelatedDocuments }}</h5>
                <div class="eshop__table-container waybills">
                    <table>
                        <colgroup>
                            <col style="width:120px">
                            <col style="width:140px">
                            <col style="width:150px">
                            <col style="width:150px">
                        </colgroup>
                        <thead>
                            <tr>
                                <th class="id">{{ translations.Number | Capitalize }}</th>
                                <th>{{ translations.DocumentDate }}</th>
                                <th>{{ translations.Value }} {{ translations.Netto | Downcase }}</th>
                                <th>{{ translations.Value }} {{ translations.Brutto | Downcase }}</th>
                                <th>{{ translations.Currency }}</th>
                            </tr>
                        </thead>
                        <tbody class="related-documents-js {% if settings.invoicesAvailability == 'yes' -%} invoicesAvailable-js {% endif -%} {% if settings.SORAvailability == 'yes' -%} SORAvailable-js {% endif -%}" 
                            rv-if="DocumentsExist" 
                            data-url-origin="{{ page.Url }}?&deeper-lvl=true&erp-data=true&" 
                            data-url-eshop-orders="{{ page.Url }}?{{ customer-profile.OrderQueryGET | H }}=">
                        </tbody>
                    </table>
                </div>
            </div>                
        </div>
        <div class="loader-js loader big"></div>
    {% else -%}
        {% if config.B2B == false %}
            {% if page.QueryString contains 'executed-order-details' -%}
                {% assign tab = 'executed-orders' -%}
                {% assign pageQueryName = customer-profile.OrdersExecuted.PageQueryGET -%}
            {% else -%}
                {% assign tab = 'active-orders' -%}
                {% assign pageQueryName = customer-profile.OrdersActive.PageQueryGET -%}
            {% endif -%}
        {% else -%}
            {% if page.QueryString contains 'erp-orders' -%}
                {% assign tab = 'erp-orders' -%}
            {% else -%}
                {% assign tab = 'eshop-orders' -%}
            {% endif -%}
            {% assign pageQueryName = customer-profile.Orders.PageQueryGET -%}
        {% endif -%}

        {% include 'partials/common/date-format.html' -%}
        {% assign order = customer-profile.Order -%}
        {% assign orderString = customer-profile.OrderQueryGET -%}
        {% assign queries = page.QueryString | Split: '&' -%}
        {% for query in queries -%}
            {% if query contains 'page=' -%}
                {% assign pageQueryNo = query | Split: '=' | Last -%}
                {% break -%}
            {% else -%}
                {% assign pageQueryNo = 1 -%}
            {% endif -%}
        {% endfor -%}
        <div class="customer-submenu__header submenu-header">
            <div class="navigation-header">
                {% if customer.Authenticated -%}
                    {% unless page.QueryString contains 'orderHash' -%}
                        <button aria-label="{{translations.Back}}" class="pure-button load-first-lvl-js parent-container-reload-js" data-template="partials/customer-profile/orders/orders.html" data-url="{{ page.Url }}?{% if tab -%}tab={{tab}}{% endif -%}">
                            <svg aria-hidden="true" width="24" height="24">
                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#long-arrow-left-{{settings.iconStyle}}"></use>
                            </svg>
                        </button>
                    {% endunless -%}
                {% endif -%}
                {{ translations.Order }} {{ order.Id }} {% if order.ERPOrderNumber != '' -%} ({{ order.ERPOrderNumber }}){% endif -%}
            </div>
            {% if order.CanCancel -%}
                {% assign canCancel = true -%}
                {% if config.B2B and order.EditingAllowed -%}
                    {% assign canCancel = false -%}
                {% endif -%}
            {% endif -%}
            {% if order.CanAccept -%}
                {% assign canAccept = true -%}
                {% if config.B2B and order.EditingAllowed -%}
                    {% assign canAccept = false -%}
                {% endif -%}
            {% endif -%}
            {% unless order.Restricted -%}
            <div class="options submenu">
                <button class="pure-button open-dropdown-js">
                    {{ translations.Options }}
                    <svg height="16" width="16" class="icon rotate-down dropdown-arrow">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
                    </svg>
                </button>
                <div class="dropdown dropdown-js hidden-js {% if canCancel or canAccept -%} header-options {% endif -%}">
                    {% if order.CanCopy -%}
                        {% unless customer.Cart.Inquiry -%}
                    <button class="pure-button copy-to-cart-js" data-id="{{order.Id}}" data-hash="{{ order.Hash }}">
                        {{ translations.CopyToCart }}
                    </button>
                        {% endunless -%}
                        {% if config.B2B and settings.inquiries == 'yes' -%}
                            {% assign inquiryExists = false -%}
                            {% for cart in customer.Carts -%}
                                {% if cart.Inquiry -%}
                                    {% assign inquiryExists = true -%}
                                    {% assign inquiryId = cart.Id -%}
                                {% endif -%}
                            {% endfor -%}
                    <button class="pure-button {% if customer.Cart.Inquiry -%} copy-to-cart-js {% else -%} copy-to-inquiry-js {% endif -%}" data-id="{{order.Id}}" data-hash="{{ order.Hash }}" {% unless customer.Cart.Inquiry -%} data-cart-id="{% if inquiryExists -%}{{inquiryId}}{% else -%}-1{% endif -%}" {% endunless -%}>
                        {{ translations.CopyToInquiry }}
                    </button>
                        {% endif -%}
                    {% endif -%}
                    {% capture orderReportHref -%}{% include 'partials/common/user-link.html', userLink: order.ReportUrl -%}{% endcapture -%}
                    <a class="pure-button" href="{{ orderReportHref }}" target="_blank" rel="noopener noreferrer">{{ translations.Print }}</a>
                </div>
                <div class="options-buttons">
                    {% if canCancel -%}
                        <div class="form-js form-into-data-js" data-success="{{ translations.OrderCanceled }}">
                            <input type="hidden" name="__action" value="Order/Cancel" >
                            <input type="hidden" name="id" value="{{ order.Id }}" >
                            <input type="hidden" name="hash" value="{{ order.Hash }}" >
                            <button class="secondary-action-button parent-container-reload-js cancel-order-js" data-template="partials/customer-profile/orders/order-details.html">
                                {{ translations.OrderCancel }}
                            </button>
                        </div>
                    {% endif -%}
                    {% if canAccept -%}
                        <div class="form-js no-message-js">
                            <input type="hidden" name="__action" value="Order/Accept" >
                            <input type="hidden" name="id" value="{{ order.Id }}" >
                            <input type="hidden" name="hash" value="{{ order.Hash }}" >
                            <button class="primary-action-button post-js parent-container-reload-js" data-template="partials/customer-profile/orders/order-details.html">
                                {{ translations.OrderAccept }}
                            </button>
                        </div>
                    {% endif -%}
                    {% if order.CanRestorePayment -%}
                        <div class="form-js form-into-data-js">
                            <input type="hidden" name="__action" value="Order/RestorePayment" >
                            <input type="hidden" name="id" value="{{ order.Id }}" >
                            <input type="hidden" name="hash" value="{{ order.Hash }}" >
                            <button class="primary-action-button post-js parent-container-reload-js" data-template="partials/customer-profile/orders/order-details.html">
                                {{ translations.Pay }}
                            </button>
                        </div>
                    {% endif -%}
                </div>
            </div>
            {% endunless -%}
        </div>
        <div class="messages-container-js">
            {% if order.Restricted -%}
                <div class="return-info-banner">
                    <svg width="20" height="20" class="icon" aria-hidden="true">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#info-circle-{{settings.iconStyle}}"></use>
                    </svg>
                    <span>{{ translations.RestrictedOrderViewInfo }}</span>
                </div>
            {% endif -%}
            {% if order.EditingAllowed -%}
                <div class="message-container">
                    {{translations.OrderEditable}}
                </div>
            {% endif -%}
            {% if order.Status == 7 -%}
                <div class="message-container">
                    {{translations.NotDeterminedDeliveryCostInfo}}
                </div>
            {% endif -%}
            {% if order.Status == 8 -%}
                <div class="message-container">
                    {{translations.NotDeterminedDeliveryCostSet}}
                </div>
            {% endif -%}
            {% if order.Status == 3 and config.Complaints.ReturnsEnabled -%}
                <div class="return-info-banner">
                    <svg width="20" height="20" class="icon" aria-hidden="true">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#info-circle-{{settings.iconStyle}}"></use>
                    </svg>
                    <span>{{ translations.OrderReturnDeadlineInfo | Format: config.Complaints.DaysToReturn }}</span>
                </div>
            {% endif -%}
        </div>
        <div class="details-info">
            <div class="details">
                <div class="customer-info__content {% if order.Status == 3 -%} executed {% elseif order.Status == 4 -%} canceled {% endif -%}">
                    <div class="title">{{ translations.OrdStatus }}</div>
                    <span>{{ order.StatusText | Capitalize }}</span>
                    
                    {% if order.Delivery.StatusText or order.Payment.StatusText -%}
                        <span class="additional-status">
                            (
                            {% if order.Delivery.StatusText -%}
                                {% if order.Delivery.Status == 3 or order.Delivery.Status == 4 -%}
                                    <span class="executed">
                                {% endif -%}
                                        {{ order.Delivery.StatusText }}
                                {% if order.Delivery.Status == 3 or order.Delivery.Status == 4 -%}
                                    </span>
                                {% endif -%}
                            {% endif -%}
                            {% if order.Delivery.StatusText and order.Payment.StatusText -%} / {% endif -%}
                            {% if order.Payment.StatusText -%}
                                {% if order.Payment.Status == 0 -%}
                                    <span class="not-paid">
                                {% elseif order.Payment.Status == 1 -%}
                                    <span class="paid">
                                {% else -%}
                                    <span class="partial">
                                {% endif -%}
                                        {{ order.Payment.StatusText }}
                                {% if order.Payment.Status == 0 or order.Payment.Status == 1 -%}
                                    </span>
                                {% endif -%}
                            {% endif -%}
                            )
                        </span>
                    {% endif -%}
                </div>
                
                <div class="customer-info__content">
                    <div class="title">{{ translations.BuyDate }}</div>
                    <span>{{ order.Date | Date:dateFormat }}</span>
                </div>
            </div>
            <div class="details-info__summary">
                {% include 'partials/common/order-summary.html' with order -%}
                <div class="summary">
                    <div class="title">
                        {% if order.Payment.Status == 1 -%}
                            {{ translations.Paid }}
                        {% else -%}
                            {{ translations.AmountDue }}
                        {% endif -%}
                        {{ translations.Brutto | Downcase }}
                    </div>
                    <span>
                        {{ order.OrderTotalValue | ToPrice }} {{ order.CurrencyExt }}
                    </span>
                </div>
            </div>
        </div>
        <div class="info-container-js expandable-mechanism-container-js">
            <button class="pure-button expand-data-js change-arrow-title-js" title="{{ translations.ShowDetails }}">
                {{ translations.ShowDetails }} 
                <svg height="16" width="16" class="icon rotate-down dropdown-arrow">
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
                </svg>
            </button>
            <div class="order-details expandable-js">
                    {% assign relatedOffersSize = order.RelatedOffers | Size -%}
                    {% if relatedOffersSize > 0 -%}
                    <div class="order-details__row">
                        <div class="order-details-item">
                            <div class="title">{{ translations.Offer }}</div>
                            <span>
                                {% for relatedOffer in order.RelatedOffers -%}
                                    <span class="replace-template-js parent-container-reload-js pure-button" data-template="partials/customer-profile/offers/offer-details.html" data-url="{{ page.Url }}?{{customer-profile.OfferQueryGET}}={{ relatedOffer.Id }}&tab=offer-details">{{ relatedOffer.Id }}</span>{% if forloop.index != relatedOffersSize -%}, {% endif -%}
                                {% endfor -%}
                            </span>
                        </div>
                    </div>
                    {% endif -%}
                    <div class="order-details__row">
                        {% if order.Payment.StatusText != "" -%}
                        <div class="order-details-item">
                            <div class="title">{{ translations.PaymentStatus }}</div>
                                {% if order.Payment.Status == 0 -%}
                                    <span class="canceled">
                                {% elseif order.Payment.Status == 1 -%}
                                    <span class="executed">
                                {% endif -%}
                                        <span>{{ order.Payment.StatusText }}</span>
                                {% if order.Payment.Status == 0 or order.Payment.Status == 1 -%}
                                {% endif -%}
                                </span>
                        </div>
                    {% endif -%}
                        {% if order.Payment.DueDateText != "" -%}
                        <div class="order-details-item">
                            <div class="title">{{ translations.ScheduledPaymentDate }}</div>
                            <span>{{ order.Payment.DueDateText }}</span>
                        </div>
                        {% endif -%}
                        <div class="order-details-item">
                            <div class="title">{{ translations.PaymentMethod }}</div>
                            <span>{{ order.Payment.Name }}</span>
                        </div>
                        {% if settings.buyerData == "yes" and order.Customer.Buyer.Name != '' and order.ProcessedDate != null -%}
                        <div class="order-details-item">
                            <div class="title">{{ translations.ExecutionDate }}</div>
                            <span>{{ order.ProcessedDate | Date:dateFormat }}</span>
                        </div>
                        {% endif -%}
                    </div>
                    <div class="order-details__row">
                        {% if order.SelectedDeliveryDate != order.Date and order.SelectedDeliveryDate != null -%}
                        <div class="order-details-item">
                            <div class="title">{{ translations.ScheduledDeliveryDate }}</div>
                            <span>
                                {{ order.SelectedDeliveryDate | Date:dateFormat }}
                                {% if settings.deliveryDateType == "date-and-time" -%}
                                    {{ order.SelectedDeliveryDate | Date:'HH:mm' }}
                                {% endif -%}
                            </span>
                        </div>
                        {% if settings.buyerData == "yes" and order.Customer.Buyer.Name != '' -%}
                        <div class="order-details-item">
                            <div class="title">{{ translations.BoughtBy }}</div>
                            <span>{{ order.Customer.Email }}</span>
                            {% if order.Customer.DeliveryAddress.PhoneNo != null and order.Customer.DeliveryAddress.PhoneNo != '' -%}
                            <span>{{ order.Customer.DeliveryAddress.PhoneNo }}</span>
                            {% endif -%}
                        </div>
                        {% endif -%}
                        {% elseif order.Delivery.DateText != null -%}
                            <div class="order-details-item">
                                <div class="title">{{ translations.ScheduledDeliveryDate }}</div>
                                <span>{{ order.Delivery.DateText }}</span>
                            </div>
                        {% elseif settings.buyerData == "yes" and order.Customer.Buyer.Name != '' -%}
                            <div class="order-details-item">
                                <div class="title">{{ translations.BoughtBy }}</div>
                                <span>{{ order.Customer.Email }}</span>
                                {% if order.Customer.DeliveryAddress.PhoneNo != null and order.Customer.DeliveryAddress.PhoneNo != '' -%}
                                <span>{{ order.Customer.DeliveryAddress.PhoneNo }}</span>
                                {% endif -%}
                            </div>
                        {% endif -%}
                        <div class="order-details-item">
                            <div class="title">{{ translations.DelivMethod }}</div>
                            <span>{{ order.Delivery.Name }}</span>
                        </div>
                        {% if order.Delivery.CollectionPoint != null -%}
                            <div class="order-details-item">
                                <div class="title">{{ translations.CollectionPoint }}</div>
                                    {% assign collectionPoint = order.Delivery.CollectionPoint -%}
                                    <span>{{ collectionPoint.City }} {{ collectionPoint.ZipCode }}</span>
                                    <span>{{ collectionPoint.Street }} {{ collectionPoint.StreetNo }}</span>
                                    <span>
                                        {% if collectionPoint.LocationDescription and collectionPoint.LocationDescription != '' -%}
                                            {{ collectionPoint.LocationDescription }}
                                        {% else -%}
                                            {{ collectionPoint.Name }}
                                        {% endif -%}
                                        ({{ collectionPoint.Id }})
                                    </span>
                                    {% assign cpId = order.Delivery.CollectionPointTypeId | ToInt -%}
                                    {% if cpId == 1 or cpId > 999 -%}
                                        {% if collectionPoint.OpeningHoursMonFri != null or collectionPoint.OpeningHoursSat != null or collectionPoint.OpeningHoursSun != null -%}
                                            <div class="title">{{translations.OpenHours}}</div>
                                            {% if collectionPoint.OpeningHoursMonFri != null -%}
                                                <div><span style="display: inline-block; width: 70px">{{translations.MondayFriday}}:</span> {{collectionPoint.OpeningHoursMonFri}}</div>
                                            {% endif -%}
                                            {% if collectionPoint.OpeningHoursSat != null -%}
                                                <div><span style="display: inline-block; width: 70px">{{translations.Saturday}}:</span> {{collectionPoint.OpeningHoursSat}}</div>
                                            {% endif -%}
                                            {% if collectionPoint.OpeningHoursSun != null -%}
                                                <div><span style="display: inline-block; width: 70px">{{translations.Sunday}}:</span> {{collectionPoint.OpeningHoursSun}}</div>
                                            {% endif -%}
                                        {% endif -%}
                                    {% endif -%}
                            </div>
                        {% elseif order.Customer.DeliveryAddress != null -%}
                            <div class="order-details-item">
                                <div class="title">{{ translations.DelivAddress }}</div>
                                <span>{{ order.Customer.DeliveryAddress.Name }}</span>
                                <span>{{ order.Customer.DeliveryAddress.Name2 }}</span>
                                <span>{{ order.Customer.DeliveryAddress.Street }} {{ order.Customer.DeliveryAddress.StreetNo }}<span>{% if order.Customer.DeliveryAddress.UnitNo != '' -%}/{{ order.Customer.DeliveryAddress.UnitNo }}{% endif -%}</span></span>
                                <span>{{ order.Customer.DeliveryAddress.ZipCode }} {{ order.Customer.DeliveryAddress.City }}</span>
                                <span>{{ config.Countries[order.Customer.DeliveryAddress.Country].Name }}</span>
                            </div>
                        {% endif -%}
                        {% if order.Delivery.PackageCount != null -%}
                        <div class="order-details-item">
                            <div class="title">{{ translations.PackageCount }}</div>
                            <span>{{ order.Delivery.PackageCount }}</span>
                        </div>
                        {% endif -%}
                    </div>
                    <div class="order-details__row">
                        {% if settings.buyerData == "yes" and order.Customer.Buyer != null -%}
                        <div class="order-details-item">
                            <div class="title">{{ translations.BoughtBy }}</div>
                            <span>{{ order.Customer.Email }}</span>
                            {% if order.Customer.DeliveryAddress.PhoneNo != null and order.Customer.DeliveryAddress.PhoneNo != '' -%}
                            <span>{{ order.Customer.DeliveryAddress.PhoneNo }}</span>
                            {% endif -%}
                        </div>
                        <div class="order-details-item">
                            <div class="title">{{ translations.BuyerData }}</div>
                            <span>{{ order.Customer.Buyer.Name }}</span>
                            <span>{{ order.Customer.Buyer.Name2 }}</span>
                            <span>{{ order.Customer.Buyer.Street }} {{ order.Customer.Buyer.StreetNo }}<span>{% if order.Customer.Buyer.UnitNo != '' -%}/{{ order.Customer.Buyer.UnitNo }}{% endif -%}</span></span>
                            <span>{{ order.Customer.Buyer.ZipCode }} {{ order.Customer.Buyer.City }}</span>
                            <span>{{ config.Countries[order.Customer.Buyer.Country].Name }}</span>
                            <span>{{ order.Customer.Buyer.VATEU }} {{ order.Customer.Buyer.TIN }}</span>
                        </div>
                        <div class="order-details-item">
                            <div class="title">{{ translations.ChoosenDocument }}</div>
                            <span>
                                {% if order.Customer.Invoice -%}
                                    {{ translations.Invoice }}
                                {% else -%}
                                    {{ translations.Recipe }}
                                {% endif -%}
                            </span>
                        </div>
                        {% else -%}
                            {% if order.ProcessedDate != null -%}
                        <div class="order-details-item">
                            <div class="title">{{ translations.ExecutionDate }}</div>
                            <span class="customer-info__content">{{ order.ProcessedDate | Date:dateFormat }}</span>
                        </div>
                            {% endif -%}
                        <div class="order-details-item">
                            <div class="title">{{ translations.BoughtBy }}</div>
                            <span>{{ order.Customer.Email }}</span>
                            {% if order.Customer.DeliveryAddress.PhoneNo != null and order.Customer.DeliveryAddress.PhoneNo != '' -%}
                                <span>{{ order.Customer.DeliveryAddress.PhoneNo }}</span>
                            {% endif -%}
                        </div>
                        {% unless order.Restricted -%}
                        <div class="order-details-item">
                            <div class="title">{{ translations.ChoosenDocument }}</div>
                            <span>
                            {% if order.Customer.Invoice -%}
                                {{ translations.Invoice }}
                            {% else -%}
                                {{ translations.Recipe }}
                            {% endif -%}
                            </span>
                        </div>
                        {% endunless -%}
                        {% endif -%}
                        {% if order.Customer.Invoice -%}
                            <div class="order-details-item">
                                <div class="title">{{ translations.InvoiceData }}</div>
                                <span>{{ order.Customer.InvoiceAddress.Name }}</span>
                                <span>{{ order.Customer.InvoiceAddress.Street }} {{ order.Customer.InvoiceAddress.StreetNo }}{% if order.Customer.InvoiceAddress.UnitNo != '' -%}/{{ order.Customer.InvoiceAddress.UnitNo }}{% endif -%}</span>
                                <span>{{ order.Customer.InvoiceAddress.ZipCode }} {{ order.Customer.InvoiceAddress.City }}</span>
                                <span>{{ config.Countries[order.Customer.InvoiceAddress.Country].Name }}</span>
                                <span>{{ order.Customer.VATEU }} {{ order.Customer.TIN }}</span>
                            </div>
                        {% elseif order.Customer.TIN != null and order.Customer.TIN != '' -%}
                            <div class="order-details-item">
                                <div class="title">{{ translations.RecipeData }}</div>
                                <span>{{ order.Customer.VATEU }} {{ order.Customer.TIN }}</span>
                            </div>
                        {% endif -%}
                        {% if order.Delivery.CollectionPointAddress != null -%}
                            <div class="order-details-item">
                                <div>{{ translations.ReciverData }}</div>
                                    <span>{{ order.Customer.DeliveryAddress.Street }} {{ order.Customer.DeliveryAddress.StreetNo }}{% if order.Customer.DeliveryAddress.UnitNo != '' -%}/{{ order.Customer.DeliveryAddress.UnitNo }}{% endif -%}</span>
                                    <span>{{ order.Customer.DeliveryAddress.ZipCode }} {{ order.Customer.DeliveryAddress.City }}</span>
                                    <span>{{ config.Countries[order.Customer.DeliveryAddress.Country].Name }}</span>
                            </div>
                        {% endif -%}
                    </div>
                    {% if order.Points != null or order.PointsPaid != null %}
                        <div class="order-details__row">
                            {% if order.Points != null -%}
                                <div class="order-details-item">
                                    <div class="title">{{ translations.AddedLoyaltyPoints }}</div>
                                    <span>+{{ order.Points }}</span>
                                </div>
                            {% endif -%}
                            {% if order.PointsPaid != null -%}
                                <div class="order-details-item">
                                    <div class="title">{{ translations.PointsUsed }}</div>
                                    <span>-{{ order.PointsPaid }}</span>
                                </div>
                            {% endif -%}
                        </div>
                    {% endif -%}
                    {% if order.Note != "" -%}
                    <div class="order-details-item">
                        <div class="title">{{ translations.Remarks }}</div>
                        <span>{{ order.Note }}</span>
                    </div>
                    {% endif -%}
                    {% assign ordAttrSize = 0 -%}
                    {% for headerAttr in order.Attributes -%}
                        {% if headerAttr.Value != '' -%}
                            {% assign ordAttrSize = ordAttrSize | Plus: 1 -%}
                        {% endif -%}
                    {% endfor -%}
                    {% if ordAttrSize > 0 -%}
                        {% if order.Status != 9 or order.EditingAllowed == false -%}
                            {% assign cantEdit = true -%}
                        {% endif -%}
                    {% endif -%}
                {% assign ordAttrSize = 0 -%}
                {% for headerAttr in config.Orders.AttributesEdit.Header -%}
                    {% assign intId = headerAttr.Id | ToInt -%}
                    {% unless headerAttr.Editable == false and order.Attributes[intId].Value == null -%}
                        {% assign ordAttrSize = ordAttrSize | Plus:1 -%}
                    {% endunless -%}
                {% endfor -%}
            </div>
        </div>

        {% assign waybillsSize = order.Delivery.Waybills | Size -%}
        {% if waybillsSize > 0 %}
            <div class="toggle-waybill-details">
                <input type="checkbox" id="toggle-waybill-details" class="toggle-waybills-checkbox">

                <div class="pure-button show">
                    <label for="toggle-waybill-details">
                        {{ translations.ShowWaybills }}
                        <svg height="12" width="12" class="icon rotate-down">
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
                        </svg>
                    </label>
                </div>

                <div class="pure-button hide">
                    <label for="toggle-waybill-details">
                        {{ translations.HideWaybills }}
                        <svg height="12" width="12" class="icon rotate-up" style="transform: rotate(180deg);">
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
                        </svg>
                    </label>
                </div>

                <div class="waybill-details">
                    <h5>{{ translations.Waybills }}</h5>
                    <div class="eshop__table-container waybills">
                        <table>
                            <colgroup>
                                <col style="width:200px">
                                <col style="width:100px">
                                <col style="width:100px">
                                <col style="width:100px">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th class="id">{{ translations.Number | Capitalize }}</th>
                                    <th>{{ translations.Carrier }}</th>
                                </tr>
                            </thead>
                            <tbody>
                            {% for waybill in order.Delivery.Waybills %}
                            <tr>
                                <td class="id">
                                    <a href="{{ waybill.Url }}" target="_blank" rel="noopener noreferrer">{{ waybill.Number }}</a>
                                </td>
                                <td>{{ waybill.Name }}</td>
                            </tr>
                            {% endfor %}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        {% endif -%}

        {% assign orderDocumentsSize = order.Documents | Size -%}

        {% if orderDocumentsSize > 0 and order.Restricted == false -%}
            <div class="attachements-container">
            <div class="title">{{ translations.Documents }}</div>
                <div class="attachements">
                    {% for doc in order.Documents %}
                        <div class="file-container">
                            {% capture docHref -%}{% include 'partials/common/user-link.html', userLink: doc.Url -%}{% endcapture -%}
                            <a target="_blank" href="{{ docHref }}" rel="noopener noreferrer">
                                <svg height="24" width="24" class="svgIcon">
                                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#file-invoice-{{settings.iconStyle}}"></use>
                                </svg>
                                {% if doc.Type == 1 -%}
                                    {{ translations.Invoice }}
                                {% elseif doc.Type == 2 -%}
                                    {{ translations.ProFormaInvoice }}
                                {% elseif doc.Type == 3 -%}
                                    {{ translations.CorrectingInvoice }}
                                {% else -%}
                                    {{ translations.Invoice }}
                                {% endif -%}
                            </a>
                        </div>
                    {% endfor %}
                </div>
            </div>
        {% endif -%}

        {%  assign orderAttachmentsSize = order.Attachments | Size -%}

        {% if config.Orders.AttachmentsEnabled and orderAttachmentsSize > 0 and order.Restricted == false -%}
            <div class="attachements-container">
                <div class="title">{{ translations.Attachements }}</div>
                <div class="attachements">
                    {% for file in order.Attachments -%}
                        {% assign type = file.Name | Split: '.' | Last | Downcase-%}
                        {% if type == "jfif" or type == "jpe" or type == "jpeg" or type == "jpg" -%}
                            {% assign icon = 'file-image' -%}
                        {% elseif type == "csv" -%}
                            {% assign icon = 'file-csv' -%}
                        {% elseif type == "docx" or type == "odt" or type == "doc" -%}
                            {% assign icon = 'file-word' -%}
                        {% elseif type == "xlsx" or type == "ods" or type == "xls" -%}
                            {% assign icon = 'file-spreadsheet' -%}
                        {% elseif type == "zip" or type == "rar" or type == "7zip" -%}
                            {% assign icon = 'file-archive' -%}
                        {% elseif type == "pdf" -%}
                            {% assign icon = 'file-pdf' -%}
                        {% elseif type == "txt" -%}
                            {% assign icon = 'file-alt' -%}
                        {% else -%}
                            {% assign icon = 'file' -%}
                        {% endif -%}
                        <div class="file-container file-container-js">
                            {% capture fileHref -%}{% include 'partials/common/user-link.html', userLink: file.Url -%}{% endcapture -%}
                            <a href="{{ fileHref }}">				
                                <svg height="24" width="24" class="svgIcon">
                                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#{{icon}}-{{settings.iconStyle}}"></use>
                                </svg> 
                                <span>{{ file.Name }}</span>
                            </a>
                        </div>
                    {% endfor -%}
                </div>
            </div>
        {% endif -%}
        <div class="order-products-list-js">
            {% include 'partials/order/products-partials/products.html' -%}
        </div>
    {% endif -%}
    {% if order.RelatedOrders[0] and order.Restricted == false -%}
        <div class="related-erp">
            <h5><strong>{{ translations.RelatedOrders }}</strong></h5>
            <div class="eshop__table-container">
                <table>
                    <colgroup>
                        <col style="width:120px">
                        <col style="width:140px">
                    </colgroup>
                    <thead>
                        <tr>
                            <th class="id">{{ translations.Number | Capitalize }}</th>
                            <th>{{ translations.BuyDate }}</th>
                            <th>{{ translations.Status }}</th>
                        </tr>
                    </thead>
                    {% for relatedOrder in order.RelatedOrders %}
                    <tr class="row">
                        <td class="id">
                            <a href="{{ page.BaseHref }}{{ relatedOrder.Url }}">{{relatedOrder.Id}} {% if relatedOrder.Parent %}({{ translations.Main | Downcase }}){% endif %}</a>
                        </td>
                        <td class="date">{{relatedOrder.Date | Date:dateFormat}}</td>
                        <td class="state">{{relatedOrder.StatusText}}</td>
                    </tr>
                    {% endfor %}
                </table>
            </div>
        </div>
    {% endif -%}
    {% if order.CanCancel -%}
        {% include 'partials/common/confirmation-popup.html' with 0 -%}
    {% endif -%}
</div>

`